// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import SettingIcon from 'material-ui/svg-icons/action/settings';

import withPropositionActions from '../../../proposition/decorators/withPropositionActions';
import type { ActionType } from '../../../proposition/decorators/withPropositionActions';

type Props = {
  actions: Array<{ label: string, onAction: () => any, type: ActionType }>,
  theme: any,
};

function SalesPropositionMenuItem(props: Props) {
  const { actions, theme } = props;
  return (<div>
    {actions.length === 0 && <SettingIcon color={theme.colors.disabled} />}
    {actions.length > 0 &&
      <IconMenu
        iconButtonElement={<IconButton onClick={e => e.stopPropagation()}><SettingIcon /></IconButton>}
      >
        {actions.map(({ label, onAction }) =>
          <MenuItem
            key={label}
            onClick={(e: Object) => {
              e.stopPropagation();
              onAction();
            }}
            primaryText={label}
          />,
        )}
      </IconMenu>
    }
  </div>);
}

export default withPropositionActions(withTheme(SalesPropositionMenuItem));



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/components/proposition/SalesPropositionMenuItem.js